import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Button } from '../../ui';
import { Wordmark } from '../../app/Shell';
import { PasswordForm } from '../account/PasswordForm';

/** Shown instead of the app when an admin set the password: the person must choose their own. */
export function ForcePasswordChange({ name }: { name: string }) {
  const qc = useQueryClient();
  const signOut = useMutation({
    mutationFn: () => api.post('/api/auth/logout'),
    onSettled: () => {
      qc.clear();
      qc.setQueryData(['me'], null);
    },
  });
  return (
    <div className="min-h-dvh px-6 py-8 sm:px-12">
      <Wordmark dark />
      <div className="mx-auto mt-16 max-w-md">
        <h1 className="text-[26px] font-semibold leading-tight">Choose your own password</h1>
        <p className="mt-1 text-muted">
          Welcome, {name.split(' ')[0]}. Your password was set by a manager, so pick a new one only you know before you continue.
        </p>
        <div className="mt-6 rounded-[var(--radius-panel)] border border-line bg-surface p-6">
          <PasswordForm onDone={() => qc.invalidateQueries({ queryKey: ['me'] })} submitLabel="Save password and continue" />
        </div>
        <Button variant="ghost" className="mt-4" onClick={() => signOut.mutate()}>
          Sign out instead
        </Button>
      </div>
    </div>
  );
}
